






























import { Component, Prop, Vue } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import ProjectTemplate from "@/models/project-template";
import { templateApi } from "@/api";
import { ConcretizedPlan } from "../api/task-api";

// DEV: 消すとエラーになる
@Component({})
export default class TtaskTemplateAppendModal extends Vue {
  @Prop({ required: true }) projectId!: string;
  taskTemplates: ProjectTemplate[] = [];
  newTasks: ConcretizedPlan = {
    projectId: this.projectId,
    templateId: "",
    startDate: ""
  };

  get options(): SelectOption[] {
    return this.taskTemplates.map(tpl => ({
      text: tpl.title,
      value: String(tpl.id)
    }));
  }

  public show() {
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  init() {
    this.initTemplates();
  }

  private async initTemplates() {
    this.taskTemplates = await templateApi.getAll();
  }

  validateDate() {
    // TODO: 開始日の制限があれば処理を追加
    //
    // const end = this.$refs.end as HTMLInputElement;
    // if (this.startDate <= today) {
    //   end.setCustomValidity("開始日は本日以降に設定してください");
    // } else {
    //   end.setCustomValidity("");
    // }
  }

  append() {
    this.$emit("appendTasks", this.newTasks);
    this.hide();
  }

  cancel() {
    this.hide();
  }
}
